{
  "it": {
    "issue": {
      "actions": {
        "approve_for_customer": "Approva per il cliente",
        "assign": "Assegna",
        "collapse": "Comprimi segnalazioni",
        "create_category": "Aggiungi nuova categoria",
        "create_issue": "Crea segnalazione",
        "create_issue_customer": "Invia segnalazione",
        "delete": "Elimina segnalazione",
        "expand": "Espandi segnalazioni",
        "export_images": "Scarica immagini",
        "hideActivity": "Nascondi cronologia",
        "openConversation": "Apri conversazione",
        "reject_for_customer": "Rifiuta per il cliente",
        "show": "Mostra segnalazione",
        "showActivity": "Mostra cronologia",
        "startConversation": "Avvia conversazione",
        "start_conversation": "Avvia una conversazione su questa segnalazione",
        "undo_customer_approval": "Annulla l'approvazione del cliente",
        "undo_customer_rejection": "Annulla il rifiuto del cliente",
        "update": "Aggiorna segnalazioni"
      },
      "attributes": {
        "approval_status": "Approvazione cliente",
        "assignee": "Responsabile",
        "category": "Categoria",
        "created_at": "Creato",
        "deadline": "Scadenza",
        "description": "Descrizione",
        "issue_list_type": "Elenco segnalazioni",
        "name": "Nome",
        "responsible": "Responsabile",
        "status": "Stato",
        "statuses": {
          "approval_not_requested": "Non richiesta",
          "approval_requested": "Richiesta",
          "approved": "Approvata",
          "completed": "Completata",
          "created": "Aperta",
          "declined": "Rifiutata",
          "inbox": "Inviata",
          "not_completed": "Non completata",
          "ongoing": "In corso"
        },
        "updated_at": "Ultimo aggiornamento"
      },
      "edit_actions": {
        "edit_category": "Categoria",
        "edit_deadline": "Scadenza",
        "edit_issue_list_type": "Elenco segnalazioni",
        "edit_responsible": "Responsabile",
        "edit_status": "Stato"
      },
      "labels": {
        "activity": "Mostra cronologia",
        "addImagesSubtitle": "Un'immagine vale più di mille parole",
        "addImagesTitle": "Aggiunga immagini per aiutarci a comprendere meglio il problema",
        "after_care_page_title": "Le Sue segnalazioni",
        "all_categories_can_be_managed_under": "Tutte le categorie possono essere gestite in",
        "approvalNotRequested": "Approvazione non richiesta",
        "approvalRequested": "Approvazione richiesta",
        "approved": "Approvata",
        "approvedInfo": "Il cliente ha approvato questa segnalazione",
        "assignee": "Responsabile",
        "cancelCustomerApproval": "Annulla richiesta di approvazione cliente",
        "collapse": "Nascondi cronologia",
        "company_settings": "impostazioni dell'organizzazione",
        "count_edit": "Modifica segnalazione | Modifica {count} segnalazioni",
        "create_new_category?": "Non trova la categoria che le serve? Ne crei una nuova.",
        "created_at": "Creato il",
        "customerApproved": "Approvata dal cliente",
        "customerRejected": "Rifiutata dal cliente",
        "deadline_date": "Scadenza",
        "description": "Descrizione",
        "descriptionSubtitle": "Utilizzi elenchi puntati e frasi brevi per aiutarci a comprendere meglio il problema",
        "descriptionTitle": "Fornisca una breve descrizione",
        "edit_category": "Modifica categoria",
        "edit_issue": "Modifica segnalazione",
        "isThisPointFixed": "Secondo Lei, è risolta?",
        "issue_category_name": "Categoria",
        "issue_status_name": "Stato",
        "issues_clear_selection": "Svuota selezione",
        "issues_select_all_pages": "Seleziona tutte le {total} segnalazioni",
        "issues_select_one": "Seleziona almeno 1 segnalazione",
        "issues_selected": "segnalazioni selezionate",
        "issues_selected_all_pages": "Tutte le {total} segnalazioni selezionate",
        "issues_selected_count": "{selected} segnalazione selezionata | {selected} segnalazioni selezionate",
        "name": "Nome",
        "new": "Crea nuova segnalazione",
        "new_category": "Nuova categoria",
        "noDescriptionYet": "Ancora nessuna descrizione",
        "no_issue_deadline": "Nessuna scadenza impostata",
        "no_issues": "Nessuna segnalazione",
        "no_responsible": "Nessun responsabile",
        "origin": "Origine",
        "reason": "Motivo",
        "redoRequest": "Ripeti richiesta",
        "requestCustomerApproval": "Richiedi approvazione cliente",
        "requested": "Richiesta",
        "requestedInfo": "Approvazione cliente richiesta",
        "resetRequest": "Reimposta richiesta",
        "responsible_of_Employee_type_last_name_or_responsible_of_Partner_type_last_name": "Responsabile",
        "return_to_overview": "Torna indietro",
        "showIssuesfor": "Mostra segnalazioni per",
        "statusExplained": "Cosa significa il colore di ogni stato",
        "subjectSubtitle": "È sufficiente una segnalazione per ogni problema. Al resto pensiamo noi",
        "subjectTitle": "Descriva il problema in poche parole",
        "unit_issues_will_be_shown_here": "Tutte le unità collegate all'elenco segnalazioni verranno mostrate qui",
        "unit_name": "Nome unità",
        "updated_at": "Ultimo aggiornamento",
        "waitingForApproval": "Questa segnalazione deve essere accettata da {client_name} prima di poter avviare una conversazione",
        "whyIsThisPointNotFixed": "Perché questa segnalazione non è risolta?",
        "youApprovedThisPoint": "Risolta secondo Lei",
        "youRejectedThisPoint": "Non risolta secondo Lei"
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Riceverà una notifica se verrà creata una nuova segnalazione.",
            "title": "Ancora nessuna segnalazione per la Sua unità"
          }
        },
        "employees": {
          "inbox": {
            "subtitle": "Quando i clienti creano nuove segnalazioni, verranno mostrate di nuovo qui.",
            "title": "Ha elaborato tutte le segnalazioni in arrivo dai clienti"
          },
          "none": {
            "subtitle": "Inizi a registrare cosa deve essere sistemato o migliorato",
            "title": "Crei la Sua prima segnalazione"
          },
          "overview": {
            "subtitle": "Crei la Sua prima segnalazione in un'unità per iniziare",
            "title": "Le segnalazioni create in tutte le Sue unità verranno mostrate qui"
          },
          "unit": {
            "title": "Tutte le segnalazioni per questa unità verranno mostrate qui"
          }
        },
        "partners": {
          "none": {
            "subtitle": "Da quando le vengono assegnate segnalazioni, saranno visibili qui",
            "title": "Nessuna segnalazione le è ancora stata assegnata"
          }
        }
      },
      "sortGroups": {
        "date": "Data",
        "deadline": "Scadenza",
        "name": "Nome"
      },
      "toasts": {
        "update": "Segnalazione aggiornata"
      },
      "validation": {
        "issue_list_type_required": "L'elenco segnalazioni è obbligatorio",
        "pleaseProvideAReason": "Indichi un motivo",
        "status_required": "Lo stato è obbligatorio"
      }
    }
  }
}
